var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDanger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      minWidth: 21
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7446 13.3207L12.7 1.45161C12.1664 0.53368 11.2271 0 10.1811 0C9.13506 0 8.17443 0.53368 7.6621 1.45161L0.617525 13.3207C0.0198035 14.2386 0.0198035 15.3486 0.553484 16.2666C1.08716 17.1845 2.02644 17.7395 3.11515 17.7395H17.183C18.2717 17.7395 19.2109 17.1845 19.7446 16.2666C20.2996 15.3486 20.2996 14.2386 19.7446 13.3207ZM18.0582 15.3273C17.9515 15.4981 17.738 15.8183 17.2043 15.8183H3.11515C2.58147 15.8183 2.368 15.4554 2.26126 15.3273C2.15452 15.1565 2.00509 14.7723 2.26126 14.3453L9.30584 2.47628C9.562 2.04933 9.98895 1.98529 10.1597 1.98529C10.3305 1.98529 10.7574 2.02798 11.0136 2.47628L18.0582 14.3453C18.3357 14.7723 18.1222 15.1565 18.0582 15.3273Z",
    fill: "#EB5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1597 4.69629C9.60468 4.69629 9.17773 5.12323 9.17773 5.67826V10.9297C9.17773 11.4847 9.60468 11.9116 10.1597 11.9116C10.7147 11.9116 11.1417 11.4847 11.1417 10.9297V5.67826C11.1417 5.16593 10.7147 4.69629 10.1597 4.69629Z",
    fill: "#EB5757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1597 12.4453C9.60468 12.4453 9.17773 12.8723 9.17773 13.4273V13.7475C9.17773 14.3025 9.60468 14.7295 10.1597 14.7295C10.7147 14.7295 11.1417 14.3025 11.1417 13.7475V13.4273C11.1417 12.8723 10.7147 12.4453 10.1597 12.4453Z",
    fill: "#EB5757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.bcad3d38.svg";
export { ForwardRef as ReactComponent };